import type { SortableFieldKey } from '../-query/type';

/**
 * URL から来る `sortColumn` の許容値。
 *
 * `satisfies` で API の union と突き合わせるため、BE 側で列が消えた・改名されたときは
 * ここが型エラーになる。
 */
const WORKFORCE_SORT_COLUMNS = ['PersonalName', 'EmployeeNumber', 'JobType', 'Department', 'Position', 'AssignedLocation', 'EmployeeHireDate', 'EmployeeTerminationDate', 'BoardMemberInaugurationDate', 'BoardMemberRetirementDate', 'ContractorContractStartDate', 'ContractorContractEndDate', 'WorkforceMemberStartDate', 'WorkforceMemberEndDate', 'EmploymentType', 'ContractorType', 'BoardMemberType', 'CollaboratorType'] as const satisfies readonly SortableFieldKey[];
export function isWorkforceSortColumn(value: string | undefined): value is SortableFieldKey {
  return value !== undefined && (WORKFORCE_SORT_COLUMNS as readonly string[]).includes(value);
}
export { WORKFORCE_SORT_COLUMNS };